/*
** @desc:   对cookie操作的封装
** @author: yikuang@sohu-inc.com
** @date:   2017-05-12
*/

var CookieUtil = {
    // 获取cookie
    get: function (name) {
        var re = new RegExp("\\b" + name + "=([^;]*)\\b");
        var arr = re.exec(document.cookie);
        return arr ? decodeURIComponent(arr[1]) : null;
    },
    // 设置cookie（expires既可以传距离当前时间的毫秒数，也可以传具体的日期对象）
    set: function (name, value, expires, path, domain, secure) {
        var expires = expires || null;
        var path = path || '/';
        var domain = domain || null;
        var secure = secure || false;
        var now = new Date();

        // 如果传入的expires值是毫秒数，则表示过期时间与当前时间的毫秒差
        if (typeof expires === 'number') {
            now.setTime(now.getTime() + Number(expires));
            expires = now;
        }

        document.cookie = name + "=" + encodeURIComponent(value) + ((expires === null) ? "" : ("; expires=" + expires.toGMTString())) + ((path === null) ? "" : ("; path=" + path)) + ((domain === null) ? "" : ("; domain=" + domain)) + ((secure === true) ? "; secure" : "");
    },
    // 删除cookie
    remove: function (name, path, domain) {
        if(this.get(name)){
            path = path || '/';
            document.cookie = name + '=' + '; expires=Thu, 01-Jan-70 00:00:01 GMT; path=' + path + (domain ? ('; domain=' + domain) : '');
        }
    }
}

export default CookieUtil;